import { CTypeModel } from '@y42/model';
import { IconName } from '@fortawesome/fontawesome-svg-core';
import { DatasourceTableSettingsBase } from '../../state';

export interface DatasourceTableSettingsDialogData {
  tableSettings: Array<[string, DatasourceTableSettingsBase]>;
  activeDatasourceSettings: { typeModel: CTypeModel; name: string };
}

export interface DatasourceTableSettingsDialogResult {
  tableSettings: Array<readonly [string, Omit<DatasourceTableSettingsBase, '$schema'>]>;
}

export const DatasourceTableSettingsCsvOptionsPropertyName: keyof DatasourceTableSettingsBase = 'csv_options';
export const DatasourceTableSettingsWriteSettingsPropertyName: keyof DatasourceTableSettingsBase =
  '_datos_write_settings';

export const DatasourceTableSettingsNavigationsConstant: {
  [key: string]: DatasourceTableSettingsNavigationsInterface;
} = {
  [DatasourceTableSettingsCsvOptionsPropertyName]: {
    color: 'green',
    title: 'CSV Import Settings',
    logo: 'file-csv',
  },
  [DatasourceTableSettingsWriteSettingsPropertyName]: {
    color: 'red',
    title: 'Object Flattening',
    logo: 'brackets-curly',
  },
};

export interface DatasourceTableSettingsNavigationsInterface {
  color: string;
  title: string;
  logo: IconName;
}
